import React from 'react';

const SearchFilterIcon = () => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<path
				d='M14.25 11.25H2.25C2.05109 11.25 1.86032 11.329 1.71967 11.4697C1.57902 11.6103 1.5 11.8011 1.5 12C1.5 12.1989 1.57902 12.3897 1.71967 12.5303C1.86032 12.671 2.05109 12.75 2.25 12.75H14.25C14.4489 12.75 14.6397 12.671 14.7803 12.5303C14.921 12.3897 15 12.1989 15 12C15 11.8011 14.921 11.6103 14.7803 11.4697C14.6397 11.329 14.4489 11.25 14.25 11.25Z'
				fill='#4D4DB3'
			/>
			<path
				d='M21.75 6.75H2.25C2.05109 6.75 1.86032 6.82902 1.71967 6.96967C1.57902 7.11032 1.5 7.30109 1.5 7.5C1.5 7.69891 1.57902 7.88968 1.71967 8.03033C1.86032 8.17098 2.05109 8.25 2.25 8.25H21.75C21.9489 8.25 22.1397 8.17098 22.2803 8.03033C22.421 7.88968 22.5 7.69891 22.5 7.5C22.5 7.30109 22.421 7.11032 22.2803 6.96967C22.1397 6.82902 21.9489 6.75 21.75 6.75Z'
				fill='#4D4DB3'
			/>
			<path
				d='M6.75 15.75H2.25C2.05109 15.75 1.86032 15.829 1.71967 15.9697C1.57902 16.1103 1.5 16.3011 1.5 16.5C1.5 16.6989 1.57902 16.8897 1.71967 17.0303C1.86032 17.171 2.05109 17.25 2.25 17.25H6.75C6.94891 17.25 7.13968 17.171 7.28033 17.0303C7.42098 16.8897 7.5 16.6989 7.5 16.5C7.5 16.3011 7.42098 16.1103 7.28033 15.9697C7.13968 15.829 6.94891 15.75 6.75 15.75Z'
				fill='#4D4DB3'
			/>
		</svg>
	);
};

export default SearchFilterIcon;
